import { useForm } from '@refinedev/react-hook-form';
import { useTranslation } from 'react-i18next';
import { HttpError } from '@refinedev/core';
import { Researcher } from '@aphp-ema/common/researchers';
import {
  type CreateResearcherDto,
  createResearcherDtoSchema,
} from '@aphp-ema/common/researchers';
import {
  formatError,
  formatSuccess,
} from '@/shared/utils/formatting/formatNotification';
import { zodResolver } from '@hookform/resolvers/zod';

/**
 * Custom hook for handling user creation form
 * @returns Form state and handlers
 */
export const useResearcherForm = () => {
  const { t } = useTranslation();

  const form = useForm<Researcher, HttpError, CreateResearcherDto>({
    resolver: zodResolver(createResearcherDtoSchema),
    mode: 'onChange',
    defaultValues: {
      role: 'researcher',
    },
    refineCoreProps: {
      redirect: 'show',
      successNotification: formatSuccess(
        `${t('notifications.userCreated')}! ${t(
          'notifications.invitationSent',
        )}`,
      ),
      errorNotification: (error) =>
        formatError(error, t('pages.users.create.error')),
    },
  });

  return form;
};
